import { Actions } from '../actions/Notifications';
import { INotificationMessagePayload } from 'src/Common/Models/Notifications';

import { cloneDeep } from 'lodash-es';
// import { UATConstants } from "src/Common/Models/UATConstants";

export const initialState: INotificationMessagePayload[] = [];
const notificationsReducer = (
  state: any = { updateNotifications: initialState, showNotification: true },
  action: any
) => {
  switch (action.type) {
    case Actions.SET_NOTIFICATIONS:
      return {
        ...state,
        updateNotifications: cloneDeep(action.payload),
      };
    case Actions.ONOROFF_NOTIFICATIONS:
      return {
        ...state,
        showNotification: cloneDeep(action.payload),
      };
    default:
      return { ...state };
  }
};
export default notificationsReducer;
